import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c5818ca")

_pushScopeId("data-v-1c5818ca")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = {
  key: 0,
  class: "cover-wrapper"
}
const _hoisted_3 = {
  key: 0,
  class: "message-board"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "留言纪录", -1)
const _hoisted_5 = { class: "message-action" }
const _hoisted_6 = {
  key: 1,
  class: "detail-wrapper-bg"
}
const _hoisted_7 = { class: "detail-wrapper" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "detail-wrapper-title" }, [
  /*#__PURE__*/_createVNode("span", null, "我的留言纪录")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "detail-wrapper-content"
}
const _hoisted_10 = { class: "item-top" }
const _hoisted_11 = { class: "item-top-left" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "item-top-right" }
const _hoisted_14 = { class: "item-bottom" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vue_danmaku = _resolveComponent("vue-danmaku")
  const _component_Back = _resolveComponent("Back")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (!_ctx.showDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              (_ctx.modules.message)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode(_component_vue_danmaku, {
                      ref: "danmaku",
                      class: "message-board-container",
                      danmus: _ctx.danmus,
                      fontSize: 24,
                      extraStyle: `color:#333333;`,
                      speeds: 50,
                      loop: true,
                      randomChannel: true,
                      debounce: 1000,
                      useSlot: ""
                    }, {
                      dm: _withId(({ index, danmu }) => [
                        _createVNode("div", {
                          class: `message-item message-item-${index % 3}`
                        }, [
                          _createVNode("img", {
                            src: danmu.avatar
                          }, null, 8, ["src"]),
                          _createVNode("span", null, _toDisplayString(danmu.name) + "：" + _toDisplayString(danmu.text), 1)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["danmus"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", {
                class: "message-detail",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)), ["stop","prevent"]))
              }, [
                _hoisted_4
              ]),
              _createVNode("div", _hoisted_5, [
                _withDirectives(_createVNode("input", {
                  placeholder: "点我发布留言",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.myMessage = $event))
                }, null, 512), [
                  [_vModelText, _ctx.myMessage]
                ]),
                _createVNode("span", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.messageAdd && _ctx.messageAdd(...args)), ["stop","prevent"]))
                }, "发送")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                (_ctx.list && _ctx.list.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (i, k) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "detail-wrapper-content-item",
                          key: k
                        }, [
                          _createVNode("div", _hoisted_10, [
                            _createVNode("div", _hoisted_11, [
                              (i.account && i.account.avatar)
                                ? (_openBlock(), _createBlock("img", {
                                    key: 0,
                                    src: i.account.avatar
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true),
                              (i.account && i.account.account_name)
                                ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(i.account.account_name), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_13, [
                              _createVNode("span", null, _toDisplayString(i.create_time), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_14, [
                            _createVNode("p", null, _toDisplayString(i.content), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail)
          ? (_openBlock(), _createBlock(_component_Back, {
              key: 2,
              onAction: _ctx.goBack
            }, null, 8, ["onAction"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})